// src/utils/bookingUtils.js

/**
 * Check if a booking is currently active
 */
export const isCurrentBooking = (reservationDate, startTime, endTime) => {
  if (!reservationDate || !startTime) return false;

  const now = new Date();

  // Today's date (YYYY-MM-DD)
  const today = now.toISOString().split("T")[0];

  // Booking date (YYYY-MM-DD)
  const bookingDate = reservationDate.split("T")[0];

  // Date mismatch
  if (today !== bookingDate) return false;

  // Start time
  const [sh, sm] = startTime.split(":");
  const start = new Date();
  start.setHours(sh, sm, 0, 0);

  // No end time → running
  if (!endTime) {
    return now >= start;
  }

  // End time
  const [eh, em] = endTime.split(":");
  const end = new Date();
  end.setHours(eh, em, 0, 0);

  return now >= start && now <= end;
};

/**
 * Calculate duration between start & end time
 */
export const getDuration = (start, end) => {
  if (!start || !end) return "";

  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);

  const startMinutes = sh * 60 + sm;
  const endMinutes = eh * 60 + em;

  let diff = endMinutes - startMinutes;
  if (diff < 0) diff += 24 * 60; // overnight safety

  const hours = Math.floor(diff / 60);
  const minutes = diff % 60;

  if (hours && minutes) return `${hours}h ${minutes}m`;
  if (hours) return `${hours}h`;
  return `${minutes}m`;
};

export const formatTime = (time) => {
  if (!time) return "";
  const [h, m] = time.split(":");
  const hour = Number(h);
  const ampm = hour >= 12 ? "pm" : "am";
  const hr = hour % 12 || 12;
  return `${hr}:${m} ${ampm}`;
};